<script lang="ts">
  import { goto } from "$app/navigation";
  import { clearErrors } from "$lib/store/cart-context";
  import { closeAllModals, onBeforeClose } from "@thehood/svlib";

  interface IError {
    message: string;
    url?: string;
    sku?: string;
  }

  export let errors: IError[] = [];

  async function goToFn(ev: Event, error: { sku?: string; url?: string }) {
    ev.stopImmediatePropagation();
    // Clear errors and remove sku with error
    await clearErrors(error?.sku);
    allowClose = true;
    closeAllModals();
    if (error?.url) {
      goto(error.url);
    }
  }

  let allowClose = false;
  async function removeAllFn(ev: Event) {
    ev.stopImmediatePropagation();
    // Clear all errors
    await clearErrors();
    allowClose = true;
    closeAllModals();
  }
  onBeforeClose(() => allowClose);
</script>

<section>
  <h2 class="pf-600">Error!</h2>
  <ul class="items">
    {#each errors as { sku, message, url }}
      {@const [s] = sku?.split("-") ?? [""]}

      <li class="item">
        <p>{message}</p>
        {#if url}
          <button
            type="button"
            on:click={ev => {
              goToFn(ev, { url, sku });
            }}
          >
            Go to Fixture
          </button>
        {/if}
      </li>
    {/each}
  </ul>

  <div class="actions">
    <button on:click={removeAllFn}>Remove all</button>
  </div>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins";
  section {
    z-index: var(--z2);
    padding: 30px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    h2 {
      font-size: 25px;
    }
    ul {
      padding: 10px;
      margin-bottom: 20px;
      li {
        display: flex;
        gap: 20px;
        justify-content: space-between;
        margin-bottom: 10px;
        padding: 20px 0;
        p {
          padding: 10px 0;
        }
        button {
          max-width: 10rem;
          padding: 10px;
          border: 1px solid #ccc;
          background: var(--primary);
        }
      }
      li:nth-child(odd) {
        background-color: #fff;
      }
      li:nth-child(even) {
        background-color: #f8f8f8;
      }
    }

    .actions {
      width: 100%;
      display: flex;
      justify-content: end;
      gap: 10px;
      border: none;
      button {
        border: none;
        padding: 10px;
        border-radius: 4px;
        background-color: var(--danger);
      }
    }
  }
</style>
